import ModelFactory from 'business/models/ModelFactory';
import {
  BatchLoadExperimentClient,
  BatchLoadExperimentRequest,
  ScreenExpWizardClient,
} from 'business/models/Models';
import BaseService from './BaseService';

export class BatchLoadExperimentService extends BaseService {
  async validateInputCsvFile(inputCsvFile: string) {
    const bleClient: BatchLoadExperimentClient = ModelFactory(
      BatchLoadExperimentClient,
      false,
      true,
    );
    const request: BatchLoadExperimentRequest = new BatchLoadExperimentRequest();
    request.fileInput = inputCsvFile;
    return await bleClient.validateInputCsvFile(request);
  }

  async createBatchLoadExperiments(data) {
    const bleClient: BatchLoadExperimentClient = ModelFactory(
      BatchLoadExperimentClient,
      false,
      true,
    );
    return await bleClient.createBatchLoadExperiments(data);
  }

  async getProteinFormulationList() {
    const bleClient: BatchLoadExperimentClient = ModelFactory(
      BatchLoadExperimentClient,
      false,
      true,
    );
    return await bleClient.getProteinFormulationList();
  }

  async CreateNonPersistedExperiment(data) {
    const sewClient: ScreenExpWizardClient = ModelFactory(
      ScreenExpWizardClient,
      false,
      true,
    );
    return await sewClient.createExperiment(data);
  }
}
